import { render } from "./TestLetterForm.vue?vue&type=template&id=0f6f919e&scoped=true"
import script from "./TestLetterForm.vue?vue&type=script&lang=js"
export * from "./TestLetterForm.vue?vue&type=script&lang=js"

import "./TestLetterForm.vue?vue&type=style&index=0&id=0f6f919e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6f919e"]])

export default __exports__